export * from './CheckoutDetailsBlock.customer';
export * from './CheckoutDetailsBlock.delivery';
export * from './CheckoutDetailsBlock.outpost';
export * from './CheckoutDetailsBlock.pickup';
